import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.B2bGateOrder,
});
